import { useEffect, useState } from 'react';
import { captureException } from '@sentry/browser';

import routes from 'js/core_pre_webpack/routes';
import { get } from 'js/utils/api_utils';

import { FocusedNavDynamicProps } from './types';

export function useFocusedNavDynamicProps() {
  const [dynamicProps, setDynamicProps] = useState<
    FocusedNavDynamicProps | undefined
  >(undefined);

  useEffect(() => {
    get(
      routes.dynamic_props_api_v0_focused_nav_path({
        subdomain_param: 'api',
      }),
    )
      .then((data: FocusedNavDynamicProps) => {
        setDynamicProps(data);
      })
      .catch((response: Response) => {
        const error = new Error(
          `Failed to fetch focused nav dynamic props: ${response.status} ${response.statusText}`,
        );
        console.error(error);
        captureException(error);
      });
  }, []);

  return dynamicProps;
}
